'use client';

import { FC, PropsWithChildren } from 'react';
import { PaymentsProvider } from './_context/PaymentsContext';

const PaymentsLayout: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <PaymentsProvider>{children}</PaymentsProvider>
);

export default PaymentsLayout;
